var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"f-footer"},[_c('div',{staticClass:"narrow-container"},[_c('social-media-links')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }